const googleMapsApiKey =
  process.env.REACT_APP_PLACES_API_BROWSER_KEY ||
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

let mapsLoaderPromise = null;

export function hasGoogleMapsKey() {
  return Boolean(googleMapsApiKey);
}

export function loadGoogleMaps() {
  if (typeof window === "undefined") return Promise.resolve(null);
  if (window.google?.maps) return Promise.resolve(window.google.maps);
  if (mapsLoaderPromise) return mapsLoaderPromise;
  if (!googleMapsApiKey) return Promise.resolve(null);

  mapsLoaderPromise = new Promise((resolve) => {
    const existing = document.querySelector("script[data-google-maps]");
    if (existing) {
      existing.addEventListener("load", () => resolve(window.google?.maps || null));
      existing.addEventListener("error", () => resolve(null));
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.dataset.googleMaps = "true";
    script.onload = () => resolve(window.google?.maps || null);
    script.onerror = () => resolve(null);
    document.head.appendChild(script);
  });

  return mapsLoaderPromise;
}

export async function fetchPlacePredictions(inputText) {
  const text = String(inputText || "").trim();
  if (!text) return [];
  const maps = await loadGoogleMaps();
  if (!maps?.places?.AutocompleteService) return [];

  const service = new maps.places.AutocompleteService();
  return new Promise((resolve) => {
    service.getPlacePredictions({ input: text }, (results, status) => {
      if (status !== "OK" || !results) {
        resolve([]);
        return;
      }
      resolve(results.map((item) => ({
        description: item.description,
        placeId: item.place_id,
      })));
    });
  });
}

export async function fetchPlaceDetailsByPlaceId(placeId) {
  const normalizedPlaceId = String(placeId || "").trim();
  if (!normalizedPlaceId) return null;
  const maps = await loadGoogleMaps();
  if (!maps?.places?.PlacesService) return null;

  return new Promise((resolve) => {
    const service = new maps.places.PlacesService(document.createElement("div"));
    service.getDetails({
      placeId: normalizedPlaceId,
      fields: ["place_id", "name", "formatted_address", "geometry", "types"],
    }, (place, status) => {
      if (status !== "OK" || !place) {
        resolve(null);
        return;
      }
      const lat = place.geometry?.location?.lat?.();
      const lng = place.geometry?.location?.lng?.();
      resolve({
        placeId: place.place_id || normalizedPlaceId,
        name: place.name || "",
        formattedAddress: place.formatted_address || "",
        lat: Number.isFinite(Number(lat)) ? Number(lat) : null,
        lng: Number.isFinite(Number(lng)) ? Number(lng) : null,
        googleTypes: Array.isArray(place.types) ? place.types : [],
      });
    });
  });
}
